// Swagger doc: https://testapi.livexcollect.com.au/swagger/index.html

export const API_CONFIGS = {
  DEFAULT: {
    baseURL: process.env.REACT_APP_API_URL.trim(),
    apiKey: process.env.REACT_APP_API_KEY.trim()
  },
  MASTER_DATA: {
    baseURL: process.env.REACT_APP_MASTER_DATA_API_URL.trim(),
    apiKey: process.env.REACT_APP_MASTER_DATA_API_KEY.trim()
  }
};